import type { ReactNode } from 'react'
import { designTokens } from '../lib/design-tokens'
import bothelpLogo from '../assets/partners/bothelp.svg'
import agilefluentLogo from '../assets/partners/agilefluent.svg'
import mashroomLogo from '../assets/partners/mashroom.svg'
import albatoLogo from '../assets/partners/albato.svg'
import marquizLogo from '../assets/partners/marquiz.svg'
import productstarLogo from '../assets/partners/productstar.svg'
import flowmappLogo from '../assets/partners/flowmapp.svg'
import botmotherLogo from '../assets/partners/botmother.svg'
import appfollowLogo from '../assets/partners/appfollow.svg'
import designSimulatorLogo from '../assets/partners/design-simulator.svg'
import unisenderLogo from '../assets/partners/unisender.svg'
import maedLogo from '../assets/partners/maed.svg'
import phygitalLogo from '../assets/partners/phygital.svg'

export type PartnerOfferContent = {
  id: string
  logo?: { src: string; alt?: string; width?: string; height?: string } | ReactNode
  badge?: string
  description: ReactNode
  linkPrefix?: ReactNode
  linkText?: ReactNode
  linkSuffix?: ReactNode
  linkHref?: string
}

export const partnerOffers: PartnerOfferContent[] = [
  {
    id: 'agilefluent',
    logo: { src: agilefluentLogo, alt: 'AGILEfluent', width: '116px', height: '16px' },
    badge: 'Бесплатный практикум',
    description:
      'AgileFluent — сервис, который помогает IT — и digital-специалистам находить работу за границей. Вы попрактикуете язык на рабочих задачах и узнаете, как перенести дедлайн, дать обратную связь или решить конфликт в правильном tov.',
    linkPrefix: 'Перейдите по ',
    linkText: 'ссылке',
    linkSuffix: ' и заберите бесплатный практикум',
    linkHref: 'https://t.me/AFBookingBot?start=epicgrowth_epicgrowthemail',
  },
  {
    id: 'bothelp',
    logo: { src: bothelpLogo, alt: 'BotHelp', width: '116px', height: '29px' },
    badge: '21 день подписки — бесплатно',
    description:
      'Платформа для рассылок, автоворонок и чат-ботов в мессенджерах и социальных сетях. Используйте Telegram, Facebook Messenger, ВКонтакте, Viber, WhatsApp для продаж, привлечения и общения с клиентами.',
    linkPrefix: 'Перейдите по ',
    linkText: 'ссылке',
    linkSuffix: ' и зарегистрируйтесь',
    linkHref: 'https://bothelp.io/ru?ref=2867',
  },
  {
    id: 'albato',
    logo: { src: albatoLogo, alt: 'Albato', width: '82px', height: '20px' },
    badge: 'Бесплатный месяц тарифа «Базовый»',
    description:
      'Сервис интеграций, который позволяет соединять сервисы быстро и просто, как в конструкторе. Тестируйте гипотезы, создавайте MVP, настраивайте интеграции, подключайтесь к Airtable, Tilda, Я. Директ, Вконтакте, Telegram и многим другим.',
    linkPrefix: (
      <>
        Напишите промокод <span style={{ fontWeight: 600 }}>EPICGROWTH</span> в чат поддержки
        <br />
        на{' '}
      </>
    ),
    linkText: 'сайте',
    linkSuffix: ' (только для новых пользователей)',
    linkHref: 'https://albato.ru/',
  },
  {
    id: 'mashroom',
    logo: { src: mashroomLogo, alt: 'mashroom', width: '128px', height: '26px' },
    badge: 'Скидка 50% на первое мероприятие',
    description:
      'С mashroom легко создать лендинг мероприятия, принимать оплату за билеты, отправлять email-рассылки, организовать нетворкинг и общение участников, анализировать статистику и многое другое.',
    linkPrefix: 'Оставьте заявку на ',
    linkText: 'сайте',
    linkSuffix: (
      <>
        {' '}
        и назовите промокод <span style={{ fontWeight: 600 }}>EPIC</span>, когда менеджер позвонит,
        чтобы активировать учетку.
      </>
    ),
    linkHref: 'https://mashroom.online/',
  },
  {
    id: 'marquiz',
    logo: { src: marquizLogo, alt: 'Marquiz', width: '119px', height: '15px' },
    badge: 'Тариф до 100 заявок в месяц',
    description:
      'Конструктор квизов Marquiz решит ваши задачи по лидогенерации и увеличит конверсию на любом этапе воронки. Квиз поможет проверять гипотезы и принимать решения на основе данных. Создавайте опросы, собирайте обратную связь и анализируйте ответы в удобной аналитике в личном кабинете.',
    linkPrefix: 'Используйте промокод EPIC при регистрации на ',
    linkText: 'сайте',
    linkHref: 'https://www.marquiz.ru/',
  },
  {
    id: 'productstar',
    logo: { src: productstarLogo, alt: 'ProductStar', width: '110px', height: '19px' },
    badge: 'Скидка на обучение до 53%',
    description:
      'ProductStar — лидеры рынка в обучении продакт-менеджеров. За 11 лет они выпустили тысячи студентов разного уровня. Уверены, что учить одну теорию — бесполезно, поэтому обучение строят с упором на практику и формирование комьюнити. Преподаватели и менторы — топовые эксперты из крупных компаний.',
    linkPrefix: 'Перейдите по ',
    linkText: 'ссылке',
    linkSuffix: ' и оставьте заявку на сайте',
    linkHref:
      'https://new.productstar.ru/sale-for-epic-growth?utm_medium=directsale&utm_source=epicplus&source_type=email&utm_campaign=product-courses-sale&utm_content=new-clients-distribution',
  },
  {
    id: 'flowmapp',
    logo: { src: flowmappLogo, alt: 'Flowmapp', width: '125px', height: '23px' },
    badge: 'Скидка 55% на Pro Plan',
    description:
      'Платформа для проектирования цифровых продуктов, мобильных приложений, онлайн-сервисов. Собирайте и структурируйте информацию от пользователей, систематизируйте требования от бизнеса и управляйте процессами.',
    linkPrefix: (
      <>
        Используйте промокод <span style={{ fontWeight: 600 }}>EPICFLOW55</span> в специальном поле
        на{' '}
      </>
    ),
    linkText: 'сайте',
    linkHref: 'https://www.flowmapp.com/',
  },
  {
    id: 'botmother',
    logo: { src: botmotherLogo, alt: 'Botmother', width: '123px', height: '19px' },
    badge: '2 месяца на тарифе «Стартовый»‎',
    description:
      'Сделайте полезного и мощного чат-бота для бизнеса без программирования, который будет работать сразу в Telegram, Viber, WhatsApp, Facebook, Instagram, ВКонтакте и Одноклассниках.',
    linkPrefix: 'Напишите на v@botmother.com письмо «2 месяца бесплатно от Epic Growth»',
  },
  {
    id: 'appfollow',
    logo: { src: appfollowLogo, alt: 'AppFollow', width: '109px', height: '13px' },
    badge: '3 бесплатных недели',
    description:
      'Сервис для экономии времени служб поддержки и анализа отзывов. Сочетает в себе инструменты для анализа данных и управления разными частями приложения.',
    linkPrefix: 'Напишите Epic Growth в чат поддержки на ',
    linkText: 'сайте',
    linkHref: 'https://appfollow.io/',
  },
  {
    id: 'design-simulator',
    logo: {
      src: designSimulatorLogo,
      alt: 'Design Simulator',
      width: '157px',
      height: '33px',
    },
    badge: 'Скидка 15%',
    description: (
      <div>
        <p style={{ margin: 0 }}>
          Интерактивная игра, обучающая дизайну на реальных кейсах. Никаких скучных лекций, только
          практика.
        </p>
        <p style={{ margin: 0 }}>
          В игре 7 глав, которые помогут вам прокачаться в работе над UX/UI диджитал продуктов.
        </p>
      </div>
    ),
    linkPrefix: 'После прохождения двух первых глав в ',
    linkText: '@Simulator_design_bot',
    linkSuffix: (
      <>
        , введите промокод{' '}
        <span style={{ fontWeight: 600, textTransform: 'uppercase' }}>thanxtoepic</span>
      </>
    ),
    linkHref: 'https://t.me/Simulator_design_bot',
  },
  {
    id: 'unisender',
    logo: { src: unisenderLogo, alt: 'Unisender', width: '128px', height: '26px' },
    badge: '15 бесплатных рассылок',
    description: (
      <div>
        <p style={{ margin: 0 }}>
          Unisender — простой сервис email-рассылок. С ними можно собрать базу подписчиков, создать
          красивое письмо и увеличить количество клиентов через email-канал.
        </p>
        <p style={{ margin: 0 }}>
          Зарегистрируйтесь в Unisender и получите 15 бесплатных рассылок на 5000 email-адресов.
        </p>
      </div>
    ),
    linkPrefix: 'Зарегистрируйтесь по ',
    linkText: 'ссылке',
    linkHref: 'https://offer.unisender.com/for-new-users-from-epic-growth',
  },
  {
    id: 'maed',
    logo: { src: maedLogo, alt: 'MAED', width: '90px', height: '24px' },
    badge: 'Скидка 5% на «профессии» и 10% на курсы',
    description: (
      <div>
        <p style={{ margin: 0 }}>На курсах MAED можно:</p>
        <ul style={{ margin: 0, paddingLeft: designTokens.spacing.accountLkListIndent }}>
          <li>начать карьеру в маркетинге с нуля</li>
          <li>
            углубить и прокачать знания в конкретных направлениях (B2B, ABM, CRM, email, контекст,
            нейросети и др.)
          </li>
          <li>повысить квалификацию</li>
        </ul>
      </div>
    ),
    linkPrefix: (
      <>
        Введите промокод <span style={{ fontWeight: 600, textTransform: 'uppercase' }}>epic,</span>{' '}
        в специальное поле{' '}
      </>
    ),
    linkText: 'на сайте',
    linkSuffix:
      ' и получите дополнительную скидку 5% на "профессии" (включая повышения квалификации) и 10% на курсы.',
    linkHref:
      'https://maed.ru/catalog?utm_source=partners&utm_medium=epic&utm_campaign=%7Cplatnye%7Cna%7Cmarketing%7Cna%7Cna%7Cna%7Cna%7Cna%7C61010091000009',
  },
  {
    id: 'phygital',
    logo: { src: phygitalLogo, alt: 'Phygital+', width: '136px', height: '24px' },
    badge: 'Скидка 30%',
    description:
      'Phygital+ — коллаборативная AI-платформа с 30+ нейросетями для работы с визуалом. Ускоряет дизайн и маркетинг в 4 раза, предлагает 50+ готовых шаблонов, встроенного AI-ассистента, поддержку командной работы и обучение собственных AI-моделей. Генерируйте изображения, видео, тексты и улучшайте визуалы.',
    linkPrefix: (
      <>
        Введите промокод <span style={{ fontWeight: 600 }}>EPIC30</span>, в специальное поле{' '}
      </>
    ),
    linkText: 'на сайте',
    linkSuffix: ' и получите скидку 30% на любой тариф.',
    linkHref: 'https://clck.ru/3HXXEv',
  },
]
